import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { Suspense, useEffect } from "react";
import { LoadingPage } from "./components/loading.page";
import { NotFoundPage } from "./components/404";
import { Outlet } from "react-router-dom";
import Dashboard from "./pages/admin/admin.dashboard";
import Login, { isEventAuthVerified } from "./pages/admin/admin.login";
import RequestPayoutScreen from "./pages/admin/admin.request-payout";
import { Event } from "./pages/customer/event";
import { toast } from "react-toastify";
import { InternalEvents } from "./pages/internal-admin/dashboard";
import {
  INTERNAL_ADMIN_IS_LOGGEDIN,
  INTERNAL_ADMIN_LOGIN_EXPIRY,
  nowTime,
} from "./utils";
import { CreateEvent } from "./pages/internal-admin/create-event";
import { MoneyCalculator } from "./components/calculator";

const AdminOverlay = () => {
  const href = window.location.pathname;
  const { eventId } = useParams();

  useEffect(() => {
    if (href === "/admin") {
      window.location.href = "/error-page";
    }
    if (href !== "/admin/login" && eventId) {
      if (!isEventAuthVerified(eventId)) {
        window.location.href = "/admin/login";
        toast.error("Event is not authenticated, log in!");
      }
    }
  }, [href, eventId]);
  return (
    <div className='admin-overlay'>
      <Outlet />
    </div>
  );
};

const EventsOverlay = () => {
  return (
    <div className='event-overlay'>
      <Outlet />
    </div>
  );
};

const InternalAdminOverlay = () => {
  useEffect(() => {
    const isLoggedIn = JSON.parse(
      localStorage.getItem(INTERNAL_ADMIN_IS_LOGGEDIN) ?? "false"
    );
    const isInternalAdminLoginExpired =
      nowTime() >
      JSON.parse(localStorage.getItem(INTERNAL_ADMIN_LOGIN_EXPIRY) ?? "0");
    if (
      window.location.pathname !== "/internal/login" &&
      (!isLoggedIn || isInternalAdminLoginExpired)
    ) {
      window.location.href = "/internal/login";
    }
  }, []);
  return (
    <div className='admin-overlay'>
      <Outlet />
    </div>
  );
};

export function AppRouter() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          <Route path='/' element={<NotFoundPage />} />
          <Route path='/calculator' element={<MoneyCalculator />} />
          <Route path='/events' element={<EventsOverlay />}>
            <Route path='' element={<NotFoundPage type={"event"} />} />
            <Route path=':eventId' element={<Event />} />
            <Route path=':eventId/buy' element={<Event step={1} />} />
          </Route>
          <Route path='/admin' element={<AdminOverlay />}>
            <Route path='dashboard/:eventId' element={<Dashboard />} />
            <Route path='login' element={<Login />} />
            <Route
              path='request-payout/:eventId'
              element={<RequestPayoutScreen balance={0} eventData={null} />}
            />
          </Route>
          <Route path='/internal' element={<InternalAdminOverlay />}>
            <Route path='login' element={<Login type='internal-admin' />} />
            <Route
              path='admin/dashboard/:eventId'
              element={<Dashboard type='internal-admin' />}
            />
            <Route path='dashboard' element={<InternalEvents />} />
            <Route path='admin/create-event' element={<CreateEvent />} />
          </Route>
          <Route path='*' element={<NotFoundPage type={"page"} />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
